var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{directives:[{name:"ripple",rawName:"v-ripple"}],staticClass:"text-center elevation-2 pa-12 text-h5"},[_vm._v(" HTML element with v-ripple ")])}
var staticRenderFns = []

export { render, staticRenderFns }